import styled, { ITheme } from '../../../theme'

const Label = styled.div`
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.14px;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
  margin-left: 5px;
  word-break: break-all;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    font-size: 12px;
  }
`
export default Label
